<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import NavBar from '@/components/layout/NavBar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col min-h-screen bg-slate-900">
    <NavBar />
    <main class="flex-1 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 w-full">
      <h1 class="text-3xl font-bold text-white mb-6">{{ t('legal.privacy_policy.heading') }}</h1>
      <p class="text-slate-400">{{ t('legal.privacy_policy.placeholder') }}</p>
    </main>
    <AppFooter />
  </div>
</template>
